import { useMutate } from 'restful-react'
import { ChangePasswordBody } from './interfaces'

const useChangePassword = () => {
    return useMutate<any, any, any, ChangePasswordBody>('POST', '/user/changepasswordlgpd')
}

export default useChangePassword
